import { Module } from 'vuex';
import { EntityState } from '@/store/entity/types';
import { RootState } from '@/store/types';
import actions from '@/store/entity/actions';
import mutations from '@/store/entity/mutations';
import getters from '@/store/entity/getters';
import { CrudOperation } from '@/types/CrudOperation';

const state: EntityState = {
  entities: [],
  layouts: [],
  layoutClass: '',
  isModalVisible: false,
  operation: CrudOperation.read,
  prevOperation: CrudOperation.read,
};

const namespaced = true;

const entity: Module<EntityState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters,
};

export default entity;
